const chatbotData = {
  start: {
    message: "👋 Hi I am nova how may i help you today.",
    options: [
      { label: "Admissions & Enrollment", nextId: "admissions" },
      { label: "Fees & Scholarships", nextId: "fees" },
      { label: "Academics", nextId: "academics" },
      { label: "School USPs", nextId: "usps" },
      { label: "Student Life", nextId: "studentLife" },
      { label: "Safety & Well-being", nextId: "safety" },
      { label: "Hostel & Transport", nextId: "hostel" },
      { label: "Careers & Jobs", nextId: "careers" },
      { label: "School Locations & Contact", nextId: "contact" }
    ]
  },

  // --- Admissions ---
  admissions: {
    message: "📌 Admissions & Enrollment — please choose a question:",
    options: [
      { label: "What is the admission process?", nextId: "admissions_q1" },
      { label: "When do admissions open?", nextId: "admissions_q2" },
      { label: "How can I apply for admission online?", nextId: "admissions_q3" },
      { label: "What are the age criteria for admission in Nursery/Class I?", nextId: "admissions_q4" },
      { label: "Are admissions open for the current academic year?", nextId: "admissions_q5" },
      { label: "Can I visit the school before applying?", nextId: "admissions_q6" },
      { label: "What documents are required for admission?", nextId: "admissions_q7" },
      { label: "What is the admission fee structure?", nextId: "admissions_q8" },
      { label: "Is there an entrance test for new students?", nextId: "admissions_q9" },
      { label: "How can I check the status of my application?", nextId: "admissions_q10" },
      { label: "Are there any discounts available on the fee?", nextId: "admissions_q11" },
      { label: "Are there any concessions for girl children?", nextId: "admissions_q12" },
      { label: "Are there any provisions for EWS/BPL/RTE?", nextId: "admissions_q13" }
    ]
  },
  admissions_q1: { message: "For details visit: <a href='https://hermanngmeinerschoolbhimtal.org/admissions' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/admissions</a>"},
  admissions_q2: { message: "The admission process starts from August every year."},
  admissions_q3: { message: "Apply for Admissions here (Form to be created)."},
  admissions_q4: { message: "Nursery: 3+ years as of April 1.\nClass I: 5+ years as of April 1."},
  admissions_q5: { message: "Yes.Please contact us at (05942) 247073,248277/ 81264 82292. for latest updates."},
  admissions_q6: { message: "Yes. For a school tour, contact us at (05942) 247073,248277/ 81264 82292 or visit <a href='https://hermanngmeinerschoolbhimtal.org/book-tour' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/book-tour.</a>"},
  admissions_q7: { message: "For details visit: <a href='https://hermanngmeinerschoolbhimtal.org/admissions' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/admissions</a>"},
  admissions_q8: { message: "Fee details: <a href='https://hermanngmeinerschoolbhimtal.org/mandatory-disclosures' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/mandatory-disclosures</a>"},
  admissions_q9: { message: "Entrance test required from Grade IX onwards. No test for Pre-Nursery & Nursery."},
  admissions_q10: { message: "Provide your email/phone number. We will get back to you.\nOr call (05942) 247073,248277/ 81264 82292."},
  admissions_q11: { message: "Yes. Contact us at (05942) 247073,248277/ 81264 82292."},
  admissions_q12: { message: "Yes. Contact us at +(05942) 247073,248277/ 81264 82292."},
  admissions_q13: { message: "Yes. Contact us at (05942) 247073,248277/ 81264 82292 ."},

  // --- Fees ---
  fees: {
    message: "Fees & Scholarships — please choose a question:",
    options: [
      { label: "What is the fee structure for different classes?", nextId: "fees_q1" },
      { label: "Is there a discount for siblings?", nextId: "fees_q2" },
      { label: "Do you offer any scholarships or financial aid?", nextId: "fees_q3" },
      { label: "Are there any additional charges apart from tuition fees?", nextId: "fees_q4" },
      { label: "How can I pay fees online?", nextId: "fees_q5" },
      { label: "Can we pay fees in installments?", nextId: "fees_q6" },
      { label: "Who do I contact for fee-related queries?", nextId: "fees_q7" }
    ]
  },
  fees_q1: { message: "See details: <a href='https://hermanngmeinerschoolbhimtal.org/mandatory-disclosures' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/mandatory-disclosures</a>"},
  fees_q2: { message: "Yes. Call (05942) 247073,248277/ 81264 82292"},
  fees_q3: { message: "Yes. Visit: <a href='https://hermanngmeinerschoolbhimtal.org/mandatory-disclosures' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/mandatory-disclosures</a> <br />Or call (05942) 247073,248277/ 81264 82292."},
  fees_q4: { message: "For fee details visit: <a href='https://hermanngmeinerschoolbhimtal.org/mandatory-disclosures' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/mandatory-disclosures</a>"},
  fees_q5: { message: "Yes, online fee payment is available. Kindly connect at (05942) 247073,248277."},
  fees_q6: { message: "Yes. Kindly contact (05942) 247073,248277/ 81264 82292"},
  fees_q7: { message: "Please contact (05942) 247073,248277/ 81264 82292" },

  // --- Academics ---
  academics: {
    message: "📚 Academics — please choose a question:",
    options: [
      { label: "What curriculum do you follow?", nextId: "academics_q1" },
      { label: "What are the school timings?", nextId: "academics_q2" },
      { label: "What subjects are offered in senior classes?", nextId: "academics_q3" },
      { label: "Do you offer coaching for competitive exams?", nextId: "academics_q4" },
      { label: "How do you support students with learning difficulties?", nextId: "academics_q5" },
      { label: "What is your teacher-student ratio?", nextId: "academics_q6" },
      { label: "Do you offer remedial or extra classes?", nextId: "academics_q7" }
    ]
  },
  academics_q1: { message: "See details: <a href='https://hermanngmeinerschoolbhimtal.org/curriculum' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/curriculum</a>"},
  academics_q2: { message: "School timings: Monday–Saturday, 8 am – 3 pm."},
  academics_q3: { message: "Subjects list: \nSecondary → <a href='https://hermanngmeinerschoolbhimtal.org' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/</a>"},
  academics_q4: { message: "No, we do not offer competitive exam coaching."},
  academics_q5: { message: "We provide personalised attention and remedial classes to support learning needs."},
  academics_q6: { message: "The teacher-student ratio is 1:30."},
  academics_q7: { message: "Yes. We offer personalised classes to help students excel academically."},

  // --- USPs ---
  usps: {
    message: "🌟 School USPs — please choose a question:",
    options: [
      { label: "What makes HGSs different?", nextId: "usps_q1" },
      { label: "What facilities do you provide on campus?", nextId: "usps_q2" },
      { label: "Tell me more about your STEAM Lab.", nextId: "usps_q3" },
      { label: "Is there a Naval Wing in your school?", nextId: "usps_q4" },
      { label: "How do you promote sports in your curriculum?", nextId: "usps_q5" },
      { label: "Do you integrate digital tools into learning?", nextId: "usps_q6" },
      { label: "What co-curricular activities are offered?", nextId: "usps_q7" },
      { label: "What career guidance or counselling do you provide?", nextId: "usps_q8" }
    ]
  },
  usps_q1: { message: "1) No Child Invisible Program (1:30 Ratio, Quality Education) \n 2) Holistic Progress Report (360 degree assessment) \n 3) Digital Integration (Smart Panels,e-Content ) \n 4) Explorer's Lab (STEAM, ATL,ROBOTICS) \n 5) Safety in the Culture (trained support staff and security guards on duty 24/7, Zero unsupervised zones — adult presence in all active areas, ID-tagged entry/exit system for all students and visitors) \n 6) Mentor Match Program (Alumni network and Strong Teacher Connect) \n 7) Parent as Partner Framework (Regular parent feedback influencing classroom practices, Teach-Back Days” where parents share life skills, School invites parents as guest facilitators monthly) \n 8) Life Skills program (preparing for global citizenship)"},
  usps_q2: { message: "See facilities here: <a href='https://hermanngmeinerschoolbhimtal.org/infrastructure' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/infrastructure</a>"},
  usps_q3: { message: "Our STEAM Lab provides hands-on learning in science, robotics, coding, 3D printing, electronics, and design thinking. Students participate in real-world projects, hackathons, and innovation contests."},
  usps_q4: { message: "Yes. HGS Varanasi has a Naval Wing as part of its NCC program."},
  usps_q5: { message: "Sports info: <a href='https://hermanngmeinerschoolbhimtal.org/sports' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/sports</a>"},
  usps_q6: { message: "Yes. Our classrooms use Smart Panels/Projectors integrated into the curriculum."},
  usps_q7: { message: "We offer clubs, cultural trips, NCC/Scouts, and sports. Details: <a href='https://hermanngmeinerschoolbhimtal.org/house-clubs' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/house-clubs</a>,<a href='https://hermanngmeinerschoolbhimtal.org/ncc-scouts' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/ncc-scouts</a>,<a href='https://hermanngmeinerschoolbhimtal.org/trip' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/trip</a>,<a href='https://hermanngmeinerschoolbhimtal.org/ncc-scouts' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/ncc-scouts</a>"},
  usps_q8: { message: "We provide individual & group counselling, aptitude tests, career workshops, alumni talks, and mentorship for higher education & competitive exams."},

  // --- Student Life ---
  studentLife: {
    message: "🎒 Student Life — please choose a question:",
    options: [
      { label: "What clubs and societies can students join?", nextId: "studentLife_q1" },
      { label: "Are field trips and excursions organized?", nextId: "studentLife_q2" },
      { label: "Do you have a school magazine or student newspaper?", nextId: "studentLife_q3" },
      { label: "How do you ensure student safety on campus?", nextId: "studentLife_q4" }
    ]
  },
  studentLife_q1: { message: "See details: <a href='https://hermanngmeinerschoolbhimtal.org/house-clubs' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/house-clubs</a>"},
  studentLife_q2: { message: "Yes. Details: <a href='https://hermanngmeinerschoolbhimtal.org/trips' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/trips</a>"},
  studentLife_q3: { message: "Yes. The school publishes an annual magazine."},
  studentLife_q4: { message: "✔ CCTV Cameras in every classroom\n✔ 24/7 Security on campus\n✔ Bus route shared with parents\n✔ Safety workshops conducted regularly"},

  // --- Safety ---
  safety: {
    message: "🛡️ Safety & Well-being — please choose a question:",
    options: [
      { label: "What security measures are in place at the school?", nextId: "safety_q1" },
      { label: "Is there a school nurse or medical room?", nextId: "safety_q2" },
      { label: "How do you handle bullying or behavioral issues?", nextId: "safety_q3" },
      { label: "Do you have counselors on campus?", nextId: "safety_q4" },
      { label: "How do you handle emergencies?", nextId: "safety_q5" }
    ]
  },
  safety_q1: { message: "✔ CCTV Cameras in every classroom\n✔ 24/7 Security available on campus\n✔ Bus routes shared with parents\n✔ Frequent safety workshops" },
  safety_q2: { message: "Yes. We have an infirmary in every school." },
  safety_q3: { message: "We conduct counselling sessions and anti-bullying workshops every quarter." },
  safety_q4: { message: "Yes. Counsellors are available during school hours." },
  safety_q5: { message: "The school has a standard protocol and committee to handle emergencies." },

  // --- Hostel & Transport ---
  hostel: {
    message: "🏫 Hostel & Transport — please choose a question:",
    options: [
      { label: "Do you offer hostel facilities?", nextId: "hostel_q1" },
      { label: "What are the hostel charges?", nextId: "hostel_q2" },
      { label: "How do you ensure safety in hostels?", nextId: "hostel_q3" },
      { label: "Is school transport available?", nextId: "hostel_q4" },
    ]
  },
  hostel_q1: { message: "HGS Bhimtal is a residential school.\nDetails: <a href='https://hermanngmeinerschoolbhimtal.org/boarding' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/boarding</a>"},
  hostel_q2: { message: "See details: <a href='https://hermanngmeinerschoolbhimtal.org/mandatory-disclosures' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/mandatory-disclosures</a>"},
  hostel_q3: { message: "✔ CCTV Cameras\n✔ 24/7 Security\n✔ Bus route shared with parents\n✔ Frequent safety workshops"},
  hostel_q4: { message: "Yes"},

  // --- Careers ---
  careers: {
    message: "👩‍💼 Careers & Jobs — please choose a question:",
    options: [
      { label: "Are there any current job openings?", nextId: "careers_q1" },
      { label: "How can I apply for a teaching/non-teaching position?", nextId: "careers_q2" },
      { label: "What qualifications are required for teaching staff?", nextId: "careers_q3" },
      { label: "Do you offer internships or volunteer opportunities?", nextId: "careers_q4" }
    ]
  },
  careers_q1: { message: "See details: <a href='https://hermanngmeinereducationalinstitutions.org/careers' tartget='_blank'>https://hermanngmeinereducationalinstitutions.org/careers</a>"},
  careers_q2: { message: "Apply here: <a href='https://hermanngmeinereducationalinstitutions.org/careers' tartget='_blank'>https://hermanngmeinereducationalinstitutions.org/careers</a>"},
  careers_q3: { message: "Qualifications vary by subject and level. Please check job postings for specific requirements."},
  careers_q4: { message: "Yes. Internship and volunteering opportunities are available."},

  // --- Contact ---
  contact: {
    message: "📍 School Locations & Contact — please choose a question:",
    options: [
      { label: "Where is the nearest HGS?", nextId: "contact_q1" },
      { label: "How do I contact the principal or administration office?", nextId: "contact_q2" },
      { label: "What are the visiting hours for parents?", nextId: "contact_q3" },
      { label: "Is there a helpline number for urgent queries?", nextId: "contact_q4" },
      { label: "Can I schedule a school tour?", nextId: "contact_q5" }
    ] 
  },
  contact_q1: { message: "Find schools here: <a href='https://hermanngmeinereducationalinstitutions.org/' tartget='_blank'>https://hermanngmeinereducationalinstitutions.org/</a>"},
  contact_q2: { message: "Contact here: <a href='https://hermanngmeinerschoolbhimtal.org/contact-us' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/contact-us"},
  contact_q3: { message: "Visiting Hours: Monday–Saturday, 8 am – 4 pm."},
  contact_q4: { message: "Yes. See contact details here: <a href='https://hermanngmeinerschoolbhimtal.org/contact-us' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/contact-us</a>"},
  contact_q5: { message: "Yes. Please schedule here: <a href='https://hermanngmeinerschoolbhimtal.org/book-tour' tartget='_blank'>https://hermanngmeinerschoolbhimtal.org/book-tour</a>"},
};

export default chatbotData;
